import { Button, CardActions } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link } from 'gatsby';
import { PropsWithChildren, default as React } from 'react';
import Shop from '../shop';
import If from './If';
import Image from './Image';
import { ShopContext } from './ShopProvider';
import { TypeOcr } from './Types';

interface ProdLinkProps {
  isRemote: boolean;
  link: string;
}
function ProdLink(props: PropsWithChildren<ProdLinkProps>) {
  if (props.isRemote) {
    return <a href={props.link}>{props.children}</a>;
  } else {
    return <Link to={props.link}>{props.children}</Link>;
  }
}

export default function ProductCard(props: any) {
  const product = props;
  const image = product.variants.nodes[0].image;
  const gid = image.gatsbyImageData;
  const price = Number(product.variants.nodes[0].priceV2.amount);
  const prodLink = '/products/' + product.handle;
  const sampleLink = product.sample_pack_buy_url;
  const link = sampleLink ? sampleLink : prodLink;
  const isLocal = !sampleLink;
  const desc = product.product_card_description;
  const tags = product.tags;
  const prod = product.title;
  const type = product.productType;
  const [message, setMessage] = React.useState('ADD+');
  const shop = React.useContext(ShopContext) as Shop;

  return (
    <ProdLink link={link} isRemote={!isLocal}>
      <Box
        sx={{
          borderRadius: '0',
          height: 'max-content',

          maxWidth: '100%',

          width: '100%',
          backgroundColor: 'success.main',
          elevation: '0',
          ':hover': {
            bgcolor: 'warning.main',
            color: 'white',
            cursor: 'pointer',
          },
        }}
        alignItems='space-between'
      >
        <Stack
          width='100%'
          direction='row'
          height={{ lg: '5.5rem', md: '5.5rem' }}
          mb={3}
        >
          <Stack width='100%'>
            <TypeOcr
              justifyContent='left'
              fontSize='1rem'
              component='div'
              sx={{ wordBreak: 'break-word', p: 1 }}
            >
              {prod}
            </TypeOcr>
            <If
              value={
                !type.includes('Legacy Hardware') &&
                !tags.includes('Free') &&
                !tags.includes('Freebies') &&
                !tags.includes('Sample Pack') &&
                !tags.includes('reason') &&
                !tags.includes('firmware')
              }
            >
              <TypeOcr
                fontSize='0.8rem'
                variant='body2'
                color='text.secondary'
                sx={{ ml: 1 }}
              >
                ${Math.trunc(price)}
              </TypeOcr>
            </If>
          </Stack>
          <If
            value={
              !type.includes('Legacy Hardware') &&
              !tags.includes('Free') &&
              !tags.includes('Freebies') &&
              !tags.includes('Sample Pack') &&
              !tags.includes('reason') &&
              !tags.includes('firmware')
            }
          >
            <CardActions
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'center',
              }}
            >
              <Button
                color='info'
                variant='outlined'
                style={{
                  borderRadius: '0',
                  fontFamily: 'OCR A Std',
                  fontSize: '0.75rem',
                }}
                sx={{
                  textWrap: 'noWrap',
                  mt: 1,
                  width: '3.5rem',
                  height: '2.286rem',
                }}
                onClick={async (e: any) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setMessage('ADDING');
                  try {
                    await shop.addItemToCart(props.variants.nodes[0].id);
                    setMessage('ADDED');
                  } catch (e: any) {
                    setMessage('ERROR');
                    console.log(e);
                  }
                }}
              >
                {message}
              </Button>
            </CardActions>
          </If>
        </Stack>

        <Box display='flex' justifyContent='center' sx={{ height: 330 }}>
          <Image
            className='product-card'
            src={image.src_md}
            alt={image.altText}
          />
        </Box>
        <Box height='6rem' display='flex' alignItems='flex-end'>
          <Typography ml={1} mr={1} mb={1} align='left'>
            {desc}
          </Typography>
        </Box>
      </Box>
    </ProdLink>
  );
}
